import React from "react";
import { RowItem } from "../models/Core/row-item";
interface SpanProps extends RowItem {
    children?: any
    class?: string
    table?: boolean
}
export default function Span(props: SpanProps) {//من اجل خاصية اخفاء عمود من الجدول ما تعطي مشكلة 
    return (
        <span className={props.class }>{props.children}</span>
    );
}
